import { motion } from "motion/react";
import { Play } from "lucide-react";

export function FeaturedVideo() {
  return (
    <section className="py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-serif mb-6">
              Discover the <span className="italic text-primary">Power</span> of Strengths
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Watch this short introduction to understand how focusing on what's right with you can transform your personal and professional life.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative aspect-video rounded-[3rem] overflow-hidden shadow-2xl group"
          >
            <div className="absolute inset-0 bg-primary/5 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
            
            <iframe
              className="w-full h-full relative z-0"
              src="https://www.youtube-nocookie.com/embed/ByayrOFs7Uw"
              title="Strengthsfinder Introduction"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>

            {/* Decorative elements */}
            <div className="absolute -top-12 -right-12 w-48 h-48 bg-primary/10 rounded-full blur-3xl -z-10" />
            <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-secondary/20 rounded-full blur-3xl -z-10" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="mt-12 flex items-center justify-center gap-4 text-primary font-serif italic text-xl"
          >
            <Play className="w-6 h-6 fill-current" />
            <span>"Focus on what's right with you."</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
